import React, { Component } from 'react'
import { connect } from 'react-redux'
import { buttonColor, onControlClick, cmsColorConfig } from '../../JS/setColors'
import {
    sendCommand, sendACCommand,
    TempChange, setPowerSwitch, setEcoMode,
    VDAStatusApi, setSelectedZone, restoreValue, setzoneCount
} from '../../action/roomControlAction'
import SelectZoneScreen from './selectZoneScreen'
import ACControl from './ACControl'

class ACcontrolandSelect extends Component {
    componentDidUpdate(prePro) {
        let count = 0, index = null
        if (prePro.VDAZoneList !== this.props.VDAZoneList && this.props.VDAZoneList.length !== 1) {
            this.props.VDAZoneList.map((iterator, ind) => {
                if (iterator.hvac && iterator.hvac.temperatureValue) {
                    ++count;
                    index = ind
                }
            })
            if (count === 1) {
                console.log("we have only one zone but shows two.");
                let temp = parseInt(this.props.VDAZoneList[index].hvac.temperatureValue.slice(2, 4));
                let roomTemp = parseInt(this.props.VDAZoneList[index].hvac.currentRoomTemperature.slice(2, 4));
                this.props.setSelectedZone(this.props.VDAZoneList[index], roomTemp, index);
                this.props.TempChange(null, temp);
                this.props.setzoneCount(count);
            }
        }
    }
    render() {
        return (
            <div id="controls-ac" class="rc-controls w-100 tile-main">
                {this.props.selectedZone.zoneId ?
                    <ACControl /> :
                    <SelectZoneScreen />
                }
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        currentControl: state.store.roomControl.currentControl,
        stringConst: state.store.home.stringConst,
        guestDetail: state.store.home.guestDetails,
        menuColor: state.store.home.MenuColor,
        selectedZone: state.store.roomControl.selectedZone,
        VDAZoneList: state.store.roomControl.VDAZoneList,
        seletedIndex: state.store.roomControl.seletedIndex
    }
}

export default connect(
    mapStateToProps,
    {
        VDAStatusApi,
        setSelectedZone,
        restoreValue,
        TempChange,
        setzoneCount
    }
)(ACcontrolandSelect);
